'use strict';

angular.module('lingApp')
  .constant('JsonErrorCode', { PARSE_ERROR: -32700,
                               INVALID_REQUEST: -32600,
                               METHOD_NOT_FOUND: -32601,
                               INVALID_PARAMS: -32602,
                               INTERNAL_ERROR: -32603,
                               APPLICATION_ERROR: -32500,
                               SYSTEM_ERROR: -32400,
                               TRANSPORT_ERROR: -32300,

                               // the range -32099 .. -32000, inclusive is reserved for implementation defined server errors.
                               SERVER_ERROR: -32000,
                               VALIDATION_ERROR: -32001,
                               LOGIN_INCORRECT: -32002,
                               CLIENT_REFRESH: -32003,
                               INSUFFICIENT_PRIVILEGES: -32004,
                               BAD_SESSION: -32005,
                               SESSION_CLIENT_MISMATCH: -32006,
                               SSO_REDIRECT: -32007,
                               PASSWORD_EXPIRED: -32008
                             })
  .constant('RipEnum', (function(RipEnum) {
    RipEnum.forId = forId;
    RipEnum.set = set;
    RipEnum.init = init;

    set(RipEnum);

    function forId(enums, id) {
      return _.find(enums, { id: id });
    }

    function set(enums) {
      angular.forEach(enums, function(value) {
        angular.forEach(value, setName);
      });

      if (enums !== RipEnum) {
        angular.extend(RipEnum, enums);
      }
    }

    function setName(value, key) {
      value.name = key;
    }

    function init(enums, i18n) {
      angular.forEach(enums, function(value) {
        angular.forEach(value, setName);
      });

      angular.extend(RipEnum, enums);
      angular.extend(RipEnum, defaultEnum(i18n));
    }

    function defaultEnum(i18n) {
      return { BudgetType: { CLICK : { id: 1, label: i18n('Click') },
                             CURRENCY: { id: 2, label: i18n('Spend') },
                             LEAD: { id: 3, label: i18n('Lead') },
                             IMPRESSION: { id: 4, label: i18n('Impression') },
                           },
               IssueDetectiveStatKey: {
                 MERCHANT_USER_PAUSED: { id: 0,
                                         label: i18n('campaign user paused'),
                                         help: 'The campaign was paused by the user.',
                                         step: 'Go to Manage -> Campaigns -> Details to unpause the campaign when ready.'},
                 MERCHANT_REJECTED_BY_CLIENT_POLICY: { id: 1,
                                                       label: i18n('campaign rejected by client policy'),
                                                       help: 'The campaign budget has been rejected by client policy.  See the description for the specific client policy violated.'
                                                     },
                 MERCHANT_SYSTEM_REJECTED: { id: 2,
                                             label: i18n('campaign system rejected'),
                                             help: 'The campaign has been rejected by the system.'},
                 MERCHANT_NO_ACTIVE_LOCATION: { id: 3,
                                                label: i18n('campaign no active segment'),
                                                help: 'The campaign has no active segments.',
                                                step: 'Go to Manage -> Campaigns -> Details and add or unpause a segment.'},
                 MERCHANT_NO_BUDGET: { id: 4,
                                       label: i18n('campaign no budget'),
                                       help: 'The campaign has no budget defined.',
                                       step: 'Go to Manage -> Campaigns -> Details and add a budget.'},
                 MERCHANT_NO_ACTIVE_BUDGET: { id: 5,
                                              label: i18n('campaign no active budget'),
                                              help: 'The campaign has no active budget.',
                                              step: 'Go to Manage -> Campaigns -> Details and add or unpause a budget.'},
                 MERCHANT_FAILED_TO_IMPORT: { id: 6,
                                              label: i18n('campaign failed to import'),
                                              help: 'The campaign failed to import correctly from the campaign data feed.',
                                              step: 'Check the campaign data feed to make sure that the campaign info is correct and then try to import again.'},
                 MERCHANT_NO_NAME: { id: 7,
                                     label: i18n('campaign no name'),
                                     help: 'The campaign has no name.',
                                     step: 'Go to Manage -> Campaigns -> Details and add the campaign\'s name.'},
                 MERCHANT_CALL_TRACKING_NUMBER_NOT_PROVISIONED: { id: 8,
                                                                  label: i18n('campaign call tracking number not provisioned'),
                                                                  help: 'The campaign requested a call tracking number, but the number has not been provisioned yet.',
                                                                  step: 'Go to Manage -> Campaigns -> Details to check the call tracking number.'},
                 REVERSE_PROXY_ERROR: { id: 9,
                                        label: i18n('reverse proxy error'),
                                        help: 'The reverse proxy has an error and is not running.',
                                        step: 'Go to Admin -> Reverse Proxies to fix the error.'},
                 MERCHANT_UNABLE_TO_RUN: { id: 10,
                                           label: i18n('campaign not able to run'),
                                           help: 'The campaign is not able to run.',
                                           step: 'Fix the other problems listed in diagnostics and then reload diagnostics.'},
                 MERCHANT_HAVING_TRAFFIC_AFTER_DEACTIVATED: { id: 11,
                                                              label: i18n('campaign traffic after deactivated'),
                                                              help: 'The campaign is still getting paid search traffic after being deactivated.'},
                 MERCHANT_NO_UNDELETED_LOCATION: { id: 12,
                                                   label: i18n('campaign no undeleted segment'),
                                                   help: 'The campaign has no segment.',
                                                   step: 'Go to Manage -> Campaigns -> Details and add a segment.'},
                 MERCHANT_PARTIALLY_PROVISIONED: { id: 13,
                                                   label: i18n('campaign partially provisioned'),
                                                   help: 'The campaign is not sufficiently provisioned to run on one or more search engines.',
                                                   step: 'Go to Manage -> Campaigns -> Details and check that all steps needed to provision an campaign has been completed.  These steps are adding a category, segment, geomodifiers, destination URL and budget.'},
                 MERCHANT_CALL_TRACKING_NUMBER_NO_USAGE: { id: 14,
                                                           label: i18n('campaign call tracking but no calls'),
                                                           help: 'The campaign has a call tracking number, but has not received a call in the last 100 days.',
                                                           step: 'Go to Manage -> Campaigns -> Details to check the call tracking number.'},
                 MERCHANT_RUNNING_BUT_NO_IMPRESSIONS: { id: 15,
                                                        label: i18n('campaign running but no impressions'),
                                                        help: 'The campaign is running but has not had any impressions in the last 10 days.',
                                                        step: 'Try performance optimization measures such as adding more categories, increasing geotargeting, increasing bid cap, etc.'},
                 MERCHANT_PACING_UNDER_AT_BID_CAP: { id: 16,
                                                     label: i18n('campaign pacing under at bid cap'),
                                                     help: 'The campaign is at the bid cap and pacing under.',
                                                     step: 'If the current bid is close to the bid cap, try increasing the bid cap.  If the current bid is not close to the bid cap, try other performance optimization measures such as adding more categories or increasing geotargeting.'},

                 LOCATION_NO_ACTIVE_CATEGORY: { id: 100,
                                                label: i18n('segment no active category'),
                                                help: 'The segment does not have an active category.',
                                                step: 'Go to the specified segment in Manage -> Campaigns -> Details and activate or add a category.'},
                 LOCATION_NO_CATEGORY_KEYPHRASE: { id: 101,
                                                   label: i18n('segment no category keyphrase'),
                                                   help: 'The segment has at least one category with no keyphrase.',
                                                   step: 'Go to the specified segment in Manage -> Campaigns -> Details and add a keyphrase to at least one category in the segment'},
                 LOCATION_NO_CATEGORY_ADCOPY: { id: 102,
                                                label: i18n('segment no category adcopy'),
                                                help: 'The segment has at least one category with no adcopy.',
                                                step: 'Go to the specified segment in Manage -> Campaigns -> Details and add adcopy to at least one category  in the segment.'},
                 LOCATION_NO_ACTIVE_LOCALE: { id: 103,
                                              label: i18n('segment no active locale'),
                                              help: 'The segment does not have an active locale.',
                                              step: 'Go to the specified segment in Manage -> Campaigns -> Details and add a locale.'},
                 LOCATION_NO_LOCALE_KEYPHRASE: { id: 104,
                                                 label: i18n('segment no locale keyphrase'),
                                                 help: 'The segment has a locale with no keyphrase.',
                                                 step: 'Contact Matchcraft with the specific locale with no keyphrase'},
                 LOCATION_NO_LOCALE_GEO_TARGET: { id: 105,
                                                  label: i18n('segment no locale geo target'),
                                                  help: 'The segment has a segment with no geo target.',
                                                  step: 'Contact MatchCraft with the specific locale with no geotarget.'
                                                },
                 LOCATION_NO_DISPLAY_URL: { id: 106,
                                            label: i18n('segment no display url'),
                                            help: 'The segment does not have a display URL.',
                                            step: 'Go to the specified segment in Manage -> Campaigns -> Details and add a display URL.'},
                 LOCATION_BAD_DISPLAY_URL: { id: 107,
                                             label: i18n('segment bad display url'),
                                             help: 'The segment has a bad display URL.',
                                             step: 'Go to the specified segment in Manage -> Campaigns -> Details and fix the display URL.'},
                 LOCATION_NO_DESTINATION_URL: { id: 108,
                                                label: i18n('segment no destination url'),
                                                help: 'The segment does not have a destination url set.  The destination url is the website the user is sent to after clicking on your ad.',
                                                step: 'Go to the specified segment in Manage -> Campaigns -> Details and add a destination URL.'},
                 LOCATION_URL_UNKNOWN: { id: 109,
                                         label: i18n('segment url unknown'),
                                         help: 'The segment has an unknown host in the destination url.',
                                         step: 'Go to the specified segment in Manage -> Campaigns -> Details and fix the destination URL.'},
                 LOCATION_URL_BAD_RESPONSE_4XX: { id: 110,
                                                  label: i18n('segment url bad response 4xx'),
                                                  help: 'The request for the webpage from the server resulted in a status code of 4xx, which means that there was an error from the web browser.  A common cause is the 404 error, which means the requested webpage was not found.',
                                                  step: 'Click on the web link to check for the specific status code.  Then work with the campaign to fix the website.'},
                 LOCATION_URL_BAD_RESPONSE_5XX: { id: 111,
                                                  label: i18n('segment url bad response 5xx'),
                                                  help: 'The request for the webpage from the server resulted in a status code of 5xx, which means that there was an error from the web server.  A common cause is the 503 error, which means the server is unavailable.',
                                                  step: 'Click on the web link to check for the specific status code.  Then work with the campaign to fix the website.'},
                 LOCATION_URL_BAD_RESPONSE_OTHER: { id: 112,
                                                    label: i18n('segment url bad response other'),
                                                    help: 'The request for the webpage from the server resulted in an error.',
                                                    step: 'Click on the web link to check for the specific status code.  Then work with the campaign to fix the website.'},
                 LOCATION_URL_CONNECTION_FAILURE: { id: 113,
                                                    label: i18n('segment url connection failure'),
                                                    help: 'The connection to the web server failed.',
                                                    step: 'Click on the web link to verify the failure.  Then work with the campaign to fix the website.'},
                 LOCATION_URL_CONNECTION_TIMEOUT: { id: 114,
                                                    label: i18n('segment url connection timeout'),
                                                    help: 'There was a connection timeout when loading the webpage.',
                                                    step: 'Click on the web link to verify the connection timeout.  Then work with the campaign to fix the website.'},
                 LOCATION_URL_READ_TIMEOUT: { id: 115,
                                              label: i18n('segment url read timeout'),
                                              help: 'There was a read timeout when loading the webpage.',
                                              step: 'Click on the web link to verify the read timeout.  Then work with the campaign to fix the website.'},
                 LOCATION_URL_HOST_UNKNOWN: { id: 116,
                                              label: i18n('segment url host unknown'),
                                              help: 'The segment has an unknown host in the destination url.',
                                              step: 'Go to the specified segment in Manage -> Campaigns -> Details and fix the destination URL.'},
                 LOCATION_URL_BAD_RELATIVE_REDIRECT: { id: 117,
                                                       label: i18n('segment url bad relative redirect'),
                                                       help: 'There was a bad relative redirect when loading the website.'},
                 LOCATION_URL_TOO_MANY_REDIRECTS: { id: 118,
                                                    label: i18n('segment url too many redirects'),
                                                    help: 'There were too many redirects when loading the website.',
                                                    step: 'Click on the web link to verify the redirect problem.  Then work with the campaign to fix the website.'},
                 LOCATION_URL_NO_HEADERS_IN_RESPONSE: { id: 119,
                                                        label: i18n('segment url no headers in response'),
                                                        help: 'There were no headers in response to the webpage load.',
                                                        step: 'Click on the web link to verify the no headers in response problem.  Then work with the campaign to fix the website.'},
                 LOCATION_URL_REDIRECT_WITH_NO_NEW_LOCATION: { id: 120,
                                                               label: i18n('segment url redirect with no new segment'),
                                                               help: 'The webpage failed to load because it redirected with no new segment.',
                                                               step: 'Click on the web link to verify the redirect with no new segment problem.  Then work with the campaign to fix the website.'},
                 LOCATION_URL_MC_CONNECTIVITY_ISSUE: { id: 121,
                                                       label: i18n('segment url mc connectivity issue'),
                                                       help: 'There is a MatchCraft connectivity issue.',
                                                       step: 'Please contact MatchCraft so the connectivity issue can be fixed.'},
                 LOCATION_URL_DISPLAY_URL_MISMATCH: { id: 122,
                                                      label: i18n('segment url display url mismatch'),
                                                      help: 'The segment\'s destination URL is mismatched with the display URL.',
                                                      step: 'Go to the specified segment in Manage -> Campaigns -> Details and check the destination URL to make sure it matches the display URL.'},
                 LOCATION_NO_PROFILE_PHONE_NUMBER: { id: 123,
                                                     label: i18n('segment no profile phone number'),
                                                     help: 'The segment has no profile phone number.'},
                 LOCATION_NO_CALL_TRACKING_WEBSITE: { id: 124,
                                                      label: i18n('segment no call tracking website'),
                                                      help: 'The segment has no call tracking website.'},
                 REVERSE_PROXY_WARNING: { id: 125,
                                          label: i18n('reverse proxy warning'),
                                          help: 'The reverse proxy has a warning, but may still be running.',
                                          step: 'Go to Admin -> Reverse Proxies to fix the warning.'},
                 LOCATION_URL_CHECKER_INTERNAL_ERROR: { id: 126,
                                                        label: i18n('segment url checker internal error'),
                                                        help: 'The segment\'s destination URL failed the URL check due to an internal error.',
                                                        step: 'Please contact the website owner with the problem.'},
                 LOCATION_URL_SAFE_BROWSING_MALWARE: { id: 127,
                                                       label: i18n('segment url safe browsing malware'),
                                                       help: 'The segment\'s destination URL is potentially hosting malware and may not be safe for browsing.',
                                                       step: 'Please contact the website owner with the problem.'},
                 LOCATION_URL_SAFE_BROWSING_PHISHING: { id: 128,
                                                        label: i18n('segment url safe browsing phishing'),
                                                        help: 'The segment\'s destination URL is potentially a phishing website and may not be safe for browsing.',
                                                        step: 'Please contact the website owner with the problem.'},
                 LOCATION_URL_SAFE_BROWSING_INDETERMINANT: { id: 129,
                                                             label: i18n('segment url safe browsing indeterminant'),
                                                             help: 'The segment\'s destination URL is may not be safe for browsing.',
                                                             step: 'Please contact the website owner with the problem.'},
                 LOCATION_URL_BAD_SSL_CERTIFICATE: { id: 130,
                                                     label: i18n('segment url bad SSL certificate'),
                                                     help: 'The segment\'s destination URL as a bad SSL certificate.',
                                                     step: 'Click on the web link to verify the bad certificate.  Then work with the campaign to fix the bad SSL certificate.'},
                 LOCATION_URL_BAD_SSL_CERTIFICATE_WRONG_HOSTNAME: { id: 131,
                                                                    label: i18n('segment url bad SSL certificate wrong hostname'),
                                                                    help: 'The segment\'s destination URL has a SSL certificate with the wrong hostname.',
                                                                    step: 'Work with the campaign to obtain a SSL certificate for the campaign\'s hostname.'},
                 LOCATION_URL_BAD_CLIENT_POLICY_FAILURE: { id: 132,
                                                           label: i18n('segment url client policy failure'),
                                                           help: 'The segment\'s destination URL failed the client policy.',
                                                           step: 'Go to the specified segment in Manage -> Campaigns -> Details, check the destination URL and fix the client policy failure.'},
                 LOCATION_DISAPPROVAL_KEYWORD: { id: 133,
                                                 label: i18n('segment disapproval keyword'),
                                                 help: 'A keyword has a search engine disapproval.',
                                                 step: 'Go to the Manage -> Campaigns -> Diagnostics -> Disapprovals tab to see the specific disapproval.'},
                 LOCATION_DISAPPROVAL_ADCOPY: { id: 134,
                                                label: i18n('segment disapproval adcopy'),
                                                help: 'An adcopy has a search engine disapproval.',
                                                step: 'Go to the Manage -> Campaigns -> Diagnostics -> Disapprovals tab to see the specific disapproval.'},
                 LOCATION_URL_IS_NULL: { id: 135,
                                         label: i18n('segment url is null'),
                                         help: 'The segment\'s destination URL is null.',
                                         step: 'Go to the specified segment in Manage -> Campaigns -> Details and enter the correct destination URL.'},
                 LOCATION_URL_SOCKET_EXCEPTION: { id: 136,
                                                  label: i18n('segment url socket exception'),
                                                  help: 'The segment\'s destination URL has a socket exception and cannot connect to the server.',
                                                  step: 'Click on the web link to verify the socket exception.  Then work with the campaign to fix the bad SSL certificate.'},
                 LOCATION_UNRECOGNIZED_CATEGORY_ID: { id: 137,
                                                      label: i18n('segment unrecognized category reference'),
                                                      help: 'The segment has an unrecognized category reference.'},
                 LOCATION_UNRECOGNIZED_LOCALE_ID: { id: 138,
                                                    label: i18n('segment unrecognized locale reference'),
                                                    help: 'The segment has an unrecognized local reference.'},
                 LOCATION_URL_CANNOT_SET_DISPLAY_URL: { id: 139,
                                                        label: i18n('segment url cannot set display url'),
                                                        help: 'The segment\'s display url cannot be set.'},
                 LOCATION_UNKNOWN_POSTAL_CODE: { id: 140,
                                                 label: i18n('segment unknown postal codes'),
                                                 help: 'The segment has unknown postal codes.'},
                 LOCATION_NO_GEO_TARGETS: { id: 141,
                                            label: i18n('segment has no geo targets'),
                                            help: 'The segment has no geo targets.',
                                            step: 'Go to the specified segment in Manage -> Campaigns -> Details and set a Geographic Target.'},
                 LOCATION_URL_NOT_CHECKED_YET: { id: 142,
                                                 label: i18n('segment url not checked yet'),
                                                 help: 'The URL has not been verified to be valid yet.'},
                 LOCATION_DISAPPROVAL_IMAGE: { id: 143,
                                               label: i18n('segment disapproval image'),
                                               help: 'An image has a search engine disapproval.',
                                               step: 'Go to the Manage -> Campaigns -> Diagnostics -> Disapprovals tab to see the specific disapproval.'},

                 LOCATION_URL_VIRUS_TOTAL_UNSAFE: { id: 144,
                                                    label: i18n('virus total unsafe'),
                                                    help: 'Malware has been detected on this landing page.',
                                                    step: '' },
                 LOCATION_URL_VIRUS_TOTAL_INDETERMINANT: {id: 145,
                                                          label: i18n('virus total indeterminant'),
                                                          help: 'Malware detection indeterminate',
                                                          stop: ''},

                 BUDGET_END_DATE_IN_PAST: { id: 200, label: i18n('budget end date in past') },
                 BUDGET_START_DATE_IN_FUTURE: { id: 201, label: i18n('budget start date in future') },
                 BUDGET_REJECTED_BY_CLIENT_POLICY: { id: 202,
                                                     label: i18n('budget rejected by client policy'),
                                                     help: 'The campaign budget has been rejected by client policy.  Please see the details for the specific client policy violated.'},
                 BUDGET_TARGET_IS_MET: { id: 203, label: i18n('budget target is met') },
                 BUDGET_USER_DELETED: { id: 204, label: i18n('budget user deleted') },
                 BUDGET_SYSTEM_DELETED: { id: 205, label: i18n('budget system deleted') },
                 BUDGET_SEARCH_ENGINE_PAUSED: { id: 206, label: i18n('budget search engine paused') },

                 BUDGET_PROJECTION_UNKNOWN: { id: 220, label: i18n('budget projection unknown') },
                 BUDGET_PROJECTION_ALREADY_LATE: { id: 221, label: i18n('budget projection already late') },
                 BUDGET_PROJECTION_EARLY: { id: 222, label: i18n('budget projection early') },
                 BUDGET_PROJECTION_LATE: { id: 223, label: i18n('budget projection late') },
                 BUDGET_PROJECTION_ON_TIME: { id: 224, label: i18n('budget projection on time') },

                 CATEGORY_NO_KEYPHRASE: { id: 300,
                                          label: i18n('category no keyphrase'),
                                          help: 'The category has no keyphrases.',
                                          step: 'Go to the specified segment in Manage -> Campaigns -> Details and add a keyphrase to the categories missing one.'},
                 CATEGORY_NO_ADCOPY: { id: 301,
                                       label: i18n('category no adcopy'),
                                       help: 'The category has no adcopies.',
                                       step: 'Go to the specified segment in Manage -> Campaigns -> Details and add adcopy to the categories missing one.'},
                 CATEGORY_NO_IMAGE: { id: 302,
                                      label: i18n('category no image'),
                                      help: 'The category has no images.',
                                      step: 'Go to the specified segment in Manage -> Campaigns -> Details and add an image to the categories missing one.'},

                 LOCALE_NO_KEYPHRASE: { id: 400,
                                        label: i18n('locale no keyphrase'),
                                        help: 'The segment has a locale with no keyphrase.',
                                        step: 'Contact MatchCraft with the specific locale with no keyphrase.'},
                 LOCALE_NO_GEO_TARGET: { id: 401,
                                         label: i18n('locale no geo target'),
                                         help: 'The segment has a segment with no geo target.',
                                         step: 'Contact MatchCraft with the specific locale with no geotarget.'},
                 EVENT_NO_MERCHANT: { id: 500, label: i18n('event no campaign') },

                 SCRAPING_UNKNOWN: { id: 700, label: i18n('scraping unknown') },
                 SCRAPING_EXTRACT_CATEGORY_NAMES_FAILURE: { id: 701, label: i18n('scraping extract category names failure') },
                 SCRAPING_NO_CATEGORY_NAME_FOUND: { id: 702, label: i18n('scraping no category name found') },
                 SCRAPING_UNKNOWN_CATEGORY_NAME: { id: 703, label: i18n('scraping unknown category name') },
                 SCRAPING_UPDATE_LOCATION_CATEGORY_MAP_FAILURE: { id: 704, label: i18n('scraping update segment category map failure') },
               },
               AdvertiserStatusStatKey: {
                 ACTIVE: { id: 0, label: i18n('active') },
                 NOT_ACTIVE: { id: 1, label: i18n('not active') },
                 DELETED: { id: 2, label: i18n('deleted') },
                 PAUSED: { id: 3, label: i18n('paused') }
               },
               UserStatus: {
                 ACTIVE: { id: 0, label: i18n('ACTIVE') },
                 DELETED: { id: 1, label: i18n('DELETED') }
               },
               McReverseProxyStatus: { PENDING_SETUP: { id: 1, label: i18n('Pending Setup') },
                                       PENDING_VENDOR_REVIEW: { id: 2, label: i18n('Ready for Vendor Review') },
                                       READY_FOR_MC_REVIEW: { id: 3, label: i18n('Ready for MatchCraft Review') },
                                       PASSED_MC_REVIEW: { id: 4, label: i18n('Passed MatchCraft Review') },
                                       FAILED_MC_REVIEW: { id: 5, label: i18n('Failed MatchCraft Review') },
                                       REJECTED: { id: 6, label: i18n('Failed Vendor Review') },
                                       CANCELLED: { id: 7, label: i18n('Cancelled') },
                                       EXPIRED: { id: 8, label: i18n('Expired') }
                                     },
               AdwordsNetworkTargetBit: { GOOGLE_SEARCH: { id: 1, label: i18n('Google Search') },
                                          SEARCH_NETWORK: { id: 2, label: i18n('Search Network') },
                                          CONTENT_NETWORK: { id: 4, label: i18n('Display Network') }
                                        },
               LocationAdwordsNetworkTargetBit: { SEARCH_NETWORK: { id: 8, label: i18n('Search Partner Network')},
                                                  CONTENT_NETWORK: { id: 16, label: i18n('Display Network')}
                                                },
               AdwordsAdRotation: { OPTIMIZE: { id: 1, label: i18n('Optimize') },
                                    ROTATE: { id: 2, label: i18n('Rotate') }
                                  },
               AdwordsBudgetDelivery: { STANDARD: { id: 1, label: i18n('Standard') },
                                        ACCELERATED: { id: 2, label: i18n('Accelerated') }
                                      },
               RelationshipStatus: { SINGLE: { id: 1, label: i18n('Single') },
                                     IN_A_RELATIONSHIP: { id: 2, label: i18n('In a Relationship') },
                                     ENGAGED: { id: 3, label: i18n('Engaged') },
                                     MARRIED: { id: 4, label: i18n('Married') }
                                   },
               DemographicsUserEvent: { BIRTHDAY: { id: 1, label: i18n('Has Birthday in Next 7 Days') } },
               DemographicsEducationStatus: { HIGH_SCHOOL: { id: 1, label: i18n('In High School') },
                                              UNDERGRAD: { id: 2, label: i18n('In College') },
                                              ALUM: { id: 3, label: i18n('College Graduate') }
                                            },
               MediaFileStockProvider: { UNKNOWN: { id: 0, label: i18n('Unknown') },
                                         VEER: { id: 1, label: i18n('Veer') },
                                         THINKSTOCK: { id: 2, label: i18n('Thinkstock') }
                                       },
               Source: { ORGANIC: {id: 1, label: i18n('organic')},
                         PAID_SEARCH: {id: 2, label: i18n('paid search')},
                         PAID_CONTENT: {id: 3, label: i18n('paid content')}},
               Device: { DESKTOP: {id:1, label: i18n('desktop')},
                         HIGH_END_MOBILE: {id:2, label: i18n('high end mobile')},
                         TABLET: {id:3, label: i18n('tablet')},
                         OTHER: {id:4, label: i18n('other')}},
               MatchType: {BROAD: {id:0, label: i18n('broad')},
                           PHRASE: {id:1, label: i18n('phrase')},
                           EXACT: {id:2, label: i18n('exact')},
                           NEGATIVE_BROAD: {id:3, label: i18n('negative broad')},
                           NEGATIVE_PHRASE:{id:4, label: i18n('negative phrase')},
                           NEGATIVE_EXACT:{id:5, label: i18n('negative exact')}},
               DayOfWeek: {
                 SUN: { id: 1, label: i18n('Sunday') },
                 MON: { id: 2, label: i18n('Monday') },
                 TUE: { id: 3, label: i18n('Tuesday') },
                 WED: { id: 4, label: i18n('Wednesday') },
                 THU: { id: 5, label: i18n('Thursday') },
                 FRI: { id: 6, label: i18n('Friday') },
                 SAT: { id: 7, label: i18n('Saturday') }
               },
               Status: { ACTIVE: { id: 0, label: i18n('active') },
                         DELETED: { id: 1, label: i18n('deleted') }
                       },
               DistanceUnit: {
                 MILES: { id: 0, label: i18n('miles') },
                 KILOMETERS: { id: 1, label: i18n('km')}
               },
               DiagnosticBits: {
                 MERCHANT_USER_PAUSED: { pos: 0, label: i18n('campaign: user paused'), level: 3},
                 MERCHANT_NO_ACTIVE_LOCATION: { pos: 1, label: i18n('campaign: no active segment'), level: 3 },
                 MERCHANT_NO_CURRENT_OR_FUTURE_BUDGET: { pos: 2, label: i18n('campaign: no current or future budget'), level: 2 },
                 MERCHANT_CALL_TRACKING_NUMBER_NOT_PROVISIONED: { pos: 3, label: i18n('campaign: call tracking number not provisioned'), level: 2, help: 'The campaign requested a call tracking number, but the number has not been provisioned yet.' },
                 REVERSE_PROXY_ERROR: { pos: 4, label: i18n('reverse proxy: error'), level: 3, help: 'The reverse proxy has an error and is not running.' },
                 MERCHANT_PARTIALLY_PROVISIONED: { pos: 5, label: i18n('campaign: partially provisioned'), level: 2, help: 'The campaign is not sufficiently provisioned to run on one or more search engines.' },
                 MERCHANT_CALL_TRACKING_NUMBER_NO_USAGE: { pos: 6, label: i18n('campaign: call tracking number no usage'), level: 2, help: 'The campaign has a call tracking number, but has not received a call in the last 100 days.' },
                 MERCHANT_PACING_UNDER_AT_BID_CAP: { pos: 7, label: i18n('campaign: pacing under at bid cap'), level: 3, help: 'The campaign is at the bid cap and pacing under.' },
                 MERCHANT_RUNNING_BUT_NO_IMPRESSIONS: { pos: 8, label: i18n('campaign: running but no impressions'), level: 2, help: 'The campaign is running but has not had any impressions in the last 10 days.' },
                 LOCATION_NO_ACTIVE_CATEGORY: { pos: 9, label: i18n('segment: no active category'), level: 2 },
                 LOCATION_NO_CATEGORY_KEYPHRASE: { pos: 10, label: i18n('segment: no category keyphrase'), level: 2, help: 'The segment has at least one category with no keyphrases.' },
                 LOCATION_NO_CATEGORY_ADCOPY: { pos: 11, label: i18n('segment: no category adcopy'), level: 2, help: 'The segment has at least one category with no adcopy.' },
                 LOCATION_NO_GEO_TARGETS: { pos: 12, label: i18n('segment: no geo targets'), level: 2 },
                 LOCATION_BAD_DISPLAY_URL: { pos: 13, label: i18n('segment: bad display url'), level: 1 },
                 LOCATION_URL_ERROR: { pos: 14, label: i18n('segment: url error'), level: 2, help: 'The segment has a URL error and the webpage is failing to load.' },
                 LOCATION_URL_WARNING: { pos: 15, label: i18n('segment: url warning'), level: 1, help: 'The segment has a URL warning, but the webpage may still load.' },
                 LOCATION_NO_PROFILE_PHONE_NUMBER: { pos: 16, label: i18n('segment: no profile phone number'), level: 1, help: 'The campaign profile page does not have a phone number.' },
                 LOCATION_NO_CALL_TRACKING_WEBSITE: { pos: 17, label: i18n('segment: no call tracking website'), level: 1 },
                 REVERSE_PROXY_WARNING: { pos: 18, label: i18n('reverse proxy: warning'), level: 1, help: 'The reverse proxy has an error and is not running.' },
                 LOCATION_URL_CANNOT_SET_DISPLAY_URL: { pos: 19, label: i18n('segment: url cannot set display url'), level: 2 },
                 LOCATION_NO_DESTINATION_URL: { pos: 20, label: i18n('segment: no destination url'), level: 2 },
                 CATEGORY_NO_KEYPHRASE: { pos: 21, label: i18n('category: no keyphrase'), level: 2 },
                 CATEGORY_NO_ADCOPY: { pos: 22, label: i18n('category: no adcopy'), level: 2 },
                 CATEGORY_NO_IMAGE: { pos: 23, label: i18n('category: no image'), level: 2 },
                 LOCALE_NO_GEO_TARGET: { pos: 24, label: i18n('locale: no geo target'), level: 2 },
                 MERCHANT_UNABLE_TO_RUN: { pos: 25, label: i18n('campaign: unable to run') },
                 DISAPPROVAL_KEYWORD: { pos: 26, label: i18n('disapproval: keyword'), level: 2, help: 'The campaign has a keyword search engine disapproval.' },
                 DISAPPROVAL_ADCOPY: { pos: 27, label: i18n('disapproval: adcopy'), level: 2, help: 'The campaign has an adcopy search engine disapproval.' },
                 DISAPPROVAL_IMAGE: { pos: 28, label: i18n('disapproval: image'), level: 2, help: 'The segment has an image disapproval.'}
               },
               ReportAggregate: {
                 DAYS: { id: 'days', label: i18n('Days') },
                 WEEKS: { id: 'weeks', label: i18n('1-week Periods') },
                 TWO_WEEKS: { id: '2weeks', label: i18n('2-week Periods') },
                 MONTHS: { id: 'months', label: i18n('Months') }
               },
               LocationAdScheduleEnum: { ALL_TIMES: { id: 1, label: i18n('At all times') },
                                         SPECIFIC_PERIODS: { id: 2, label: i18n('Only during specified periods') } },
               LocationAdSchedulePeriodEnum: {   ALL_DAYS: { id: 1, label: i18n('All days') },
                                                 MONDAY_TO_SATURDAY: { id: 2, label: i18n('Monday to Saturday') },
                                                 MONDAY_TO_FRIDAY: { id: 3, label: i18n('Monday to Friday') },
                                                 SATURDAY_AND_SUNDAY: { id: 4, label: i18n('Saturday and Sunday') },
                                                 MONDAY: { id: 5, label: i18n('Monday') },
                                                 TUESDAY: { id: 6, label: i18n('Tuesday') },
                                                 WEDNESDAY: { id: 7, label: i18n('Wednesday') },
                                                 THURSDAY: { id: 8, label: i18n('Thursday') },
                                                 FRIDAY: { id: 9, label: i18n('Friday') },
                                                 SATURDAY: { id: 10, label: i18n('Saturday') },
                                                 SUNDAY: { id: 11, label: i18n('Sunday') },
                                             },
               SearchEngineDisapprovalStatusBits: { REVIEWED: { id: 1, label: i18n('Reviewed') },
                                                    PENDING_REAPPROVAL: { id: 2, label: i18n('Pending Reapproval') },
                                                    VALIDITY_UNDETERMINED: { id: 4, label: i18n('Undetermined') },
                                                    VALIDITY_IS_VALID: { id: 8, label: i18n('Valid') },
                                                    VALIDITY_IS_INVALID: { id: 16, label: i18n('Invalid') },
                                                    RESOLUTION_UNDETERMINED: { id: 32, label: i18n('None') },
                                                    RESOLUTION_DELEGATED: { id: 64, label: i18n('Delegated') },
                                                    RESOLUTION_FIXED: { id: 128, label: i18n('Fixed') },
                                                    RESOLUTION_WILL_NOT_FIX: { id: 256, label: i18n('Will Not Fix') },
                                                  },
               LocationTypeEnum: { UNKNOWN: { id: 0, label: i18n('Unknown') },
                                   SEARCH: { id: 1, label: i18n('Search') },
                                   DISPLAY: { id: 2, label: i18n('Display') },
                                   SHOPPING: { id: 3, label: i18n('Shopping') },
                                   REMARKETING_DISPLAY: { id: 4, label: i18n('Remarketing - Display') },
                                 },
               ShoppingCampaignPriorityEnum: { LOW: { id: 0, label: i18n('Low') },
                                               MEDIUM: { id: 1, label: i18n('Medium') },
                                               HIGH: { id: 2, label: i18n('High') } },
               AdwordsRmfProductDimensionEnum : { UNKNOWN: { id: 0, label: i18n('Unknown') },
                                                  PRODUCT_BIDDING_CATEGORY: { id: 1, label: i18n('Category') },
                                                  PRODUCT_BRAND: { id: 2, label: i18n('Brand') },
                                                  PRODUCT_CANONICAL_CONDITION: { id: 3, label: i18n('Condition') },
                                                  PRODUCT_CUSTOM_ATTRIBUTE: { id: 4, label: i18n('Custom label') },
                                                  PRODUCT_OFFER_ID: { id: 5, label: i18n('Item ID') },
                                                  PRODUCT_TYPE: { id: 6, label: i18n('Product type') } },
               QualityFlagEnum : { UNCATEGORIZED: { id: 0, label: i18n('Uncategorized')},
                                   RELEVANT: { id: 1, label: i18n('Relevant')},
                                   AMBIGUOUS_OR_ANS_MACHINE: { id: 2, label: i18n('Ambiguous/Ans. Machine')},
                                   IRRELEVANT: { id: 3, label: i18n('Irrelevant')},
                                   WRONG_NUMBER: { id: 4, label: i18n('Wrong Number')} },
               MonthEnum: {
                 JAN: { id: '01', label: i18n('January') },
                 FEB: { id: '02', label: i18n('February') },
                 MAR: { id: '03', label: i18n('March') },
                 APR: { id: '04', label: i18n('April') },
                 MAY: { id: '05', label: i18n('May') },
                 JUN: { id: '06', label: i18n('June') },
                 JUL: { id: '07', label: i18n('July') },
                 AUG: { id: '08', label: i18n('August') },
                 SEP: { id: '09', label: i18n('September') },
                 OCT: { id: '10', label: i18n('October') },
                 NOV: { id: '11', label: i18n('November') },
                 DEC: { id: '12', label: i18n('December') }
               },
               CurrencyEnum: {
                 EUR: { id: 1, symbol: '\u20AC', label: i18n('Euro') },
                 SEK: { id: 2, symbol: 'kr', label: i18n('Swedish Krona')},
                 USD: { id: 3, symbol: '$', label: i18n('US Dollar')},
                 DKK: { id: 4, symbol: 'kr', label: i18n('Danish Krone')},
                 GBP: { id: 5, symbol: '\u00A3', label: i18n('British Pound')},
                 AUD: { id: 6, symbol: '$', label: i18n('Australian Dollar')},
                 ZAR: { id: 7, symbol: 'R', label: i18n('South African Rand')},
                 HUF: { id: 8, symbol: 'Ft', label: i18n('Hungarian Forint')},
                 NOK: { id: 9, symbol: 'kr', label: i18n('Norwegian Krone')},
                 BRL: { id: 10, symbol: 'R$', label: i18n('Brazilian Real')},
                 NZD: { id: 11, symbol: '$', label: i18n('New Zealand Dollar')},
                 CAD: { id: 12, symbol: '$', label: i18n('Canadian Dollar')},
                 INR: { id: 13, symbol: '\u20B9', label: i18n('Indian Rupee')}
               },
               BudgetStatusBit: { UNKNOWN: { val: 0 },
                                  END_DATE_IN_PAST: { val: 1 },
                                  START_DATE_IN_FUTURE: { val: 2 },
                                  REJECTED_BY_CLIENT_POLICY: { val: 4 },
                                  TARGET_IS_MET: { val: 8 },
                                  USER_DELETED: { val: 16 },
                                  SYSTEM_DELETED: { val: 32 }
                                },
               Engine: { GOOGLE: { id: 1, label: 'Google', gym: 'G' },
                         YAHOO: { id: 2, label: 'Yahoo', gym: 'Y', deprecated: true },
                         MSN: { id: 4, label: 'Bing', gym: 'M' },
                         SAPO: { id: 8, label: 'Sapo', gym: 'S', deprecated: true },
                         FAST: { id: 16, label: 'Fast', gym: 'F', deprecated: true },
                         FACEBOOK: { id: 32, label: 'Facebook', gym: 'Z' },
                         CXENSE: {id: 64, label: 'Cxense', gym: 'C'}
                       },
               Provisioner: { AXE: { id: 1, label: 'Axe', deprecated: true },
                              GYME: { id: 2, label: 'Gyme' }
                            },
               DirectoryProfileTemplateType: { GLOBAL: { label: 'Global', availablePageTypes: [] },
                                               EDSANL: { label: 'Edsa Netherlands', availablePageTypes: [] },
                                               BASIC1: { label: 'Basic 1', availablePageTypes: ['HOME', 'SPECIAL_OFFERS', 'REVIEWS', 'GALLERY', 'CONTACT_US', 'CUSTOM']},
                                               BASIC2: { label: 'Basic 2', availablePageTypes: ['HOME', 'SPECIAL_OFFERS', 'REVIEWS', 'GALLERY', 'CONTACT_US', 'CUSTOM']},
                                               BASIC3: { label: 'Basic 3', availablePageTypes: ['HOME', 'SPECIAL_OFFERS', 'REVIEWS', 'GALLERY', 'CONTACT_US', 'CUSTOM']},
                                               BASIC4: { label: 'Basic 4', availablePageTypes: ['HOME', 'SPECIAL_OFFERS', 'REVIEWS', 'GALLERY', 'CONTACT_US', 'CUSTOM']},
                                               RIBBON1: { label: 'Ribbon 1', availablePageTypes: ['HOME', 'SPECIAL_OFFERS', 'REVIEWS', 'MAP', 'GALLERY', 'CONTACT_US', 'CUSTOM']},
                                               RIBBON2: { label: 'Ribbon 2', availablePageTypes: ['HOME', 'SPECIAL_OFFERS', 'REVIEWS', 'MAP', 'GALLERY', 'CONTACT_US', 'CUSTOM']},
                                               RIBBON3: { label: 'Ribbon 3', availablePageTypes: ['HOME', 'SPECIAL_OFFERS', 'REVIEWS', 'MAP', 'GALLERY', 'CONTACT_US', 'CUSTOM']},
                                               RIBBON4: { label: 'Ribbon 4', availablePageTypes: ['HOME', 'SPECIAL_OFFERS', 'REVIEWS', 'MAP', 'GALLERY', 'CONTACT_US', 'CUSTOM']}
                                             },
               DirectoryProfilePageType: { HOME: { title: 'Home' },
                                           SPECIAL_OFFERS: { title: 'Special Offers' },
                                           REVIEWS: { title: 'Reviews' },
                                           MAP: { title: 'Map' },
                                           GALLERY: { title: 'Gallery' },
                                           CONTACT_US: { title: 'Contact Us' },
                                           CUSTOM: { title: 'Custom' }
                                         },
               PaymentMethod: { VISA: { id: 1, label: 'Visa' },
                                MASTER_CARD: { id: 2, label: 'MasterCard' },
                                AMERICAN_EXPRESS: { id: 3, label: 'American Express' },
                                PAYPAL: { id: 4, label: 'Paypal' },
                                DINERS_CLUB: { id: 5, label: 'Diner\'s Club' },
                                INVOICE: { id: 6, label: 'Invoice' },
                                CASH: { id: 7, label: 'Cash' },
                                DEBIT_CARD: { id: 8, label: 'Debit'},
                                IDEAL: { id: 9, label: 'iDEAL' },
                                PIN: { id: 10, label: 'PIN' },
                                CHIPKNIP: { id: 11, label: 'Chipknip' },
                                CHECK: { id: 12, label: 'Check' },
                                DISCOVER: { id: 13, label: 'Discover' },
                                FINANCING: { id: 14, label: 'Financing' }
                              },
               DateRange: { LAST_24_HOURS: {id: 1, label: 'Last 24 Hours'},
                            LAST_WEEK: {id: 2, label: 'Last Week'},
                            LAST_MONTH: {id: 3, label: 'Last Month'},
                            LAST_YEAR: {id: 4, label: 'Last Year'},
                            ALL_TIME: {id: 5, label: 'All Time'}
                          },
               TaskType: {
                 UNKNOWN: {id: 0, label: 'Unknown', deprecated: true},
                 TEST_TASK: {id: 1, label: 'Test Task', injectable: true},
                 DAILY_ADMIN_TASK: {id: 2, label: 'Daily AdminTask'},
                 ASH_FEED_TASK: {id: 4, label: 'Ash Feed Task', injectable: true},
                 IMP_FEED_TASK: {id: 5, label: 'Import Feed Task', injectable: true},
                 AXE_INPUT_FEED_TASK: {id: 6, label: 'Axe Input Feed Task', deprecated: true},
                 CALL_TRACKING_TASK: {id: 8, label: 'Call Tracking Task'},
                 BUDGET_STATUS_TASK: {id: 9, label: 'Budget Status Task'},
                 DAILY_REPORT_TASK: {id: 11, label: 'Daily Report Task'},
                 GEO_FEED_TASK: {id: 12, label: 'Geo Feed Task', injectable: true},
                 IMPRESSION_FEED_TASK: {id: 13, label: 'Impression Feed Task'},
                 GYME_RECONCILIATION_TASK: {id: 14, label: 'Gyme Reconciliation Task'},
                 POST_CLICK_EVENT_TASK: {id: 15, label: 'Post Click Event Task', injectable: true},
                 GYME_RE_RECONCILIATION_TASK: {id: 16, label: 'Gyme Re-reconciliation Task'},
                 ALCHEMY_RECONCILIATION_TASK: {id: 17, label: 'Alchemy Reconciliation Task', deprecated: true},
                 ALCHEMY_RE_RECONCILIATION_TASK: {id: 18, label: 'Alchemy Re-reconciliation Task', deprecated: true},
                 TAXONOMY_REPLICATION_TASK: {id: 19, label: 'Taxonomy Replication Task', injectable: true},
                 BACKUP_CLEANSING_TASK: {id: 20, label: 'Backup Cleansing Task'},
                 GOOGLE_ANALYTICS_FEED_TASK: {id: 21, label: 'Google Analytics Feed Task'},
                 MIDAS_TOUCH_TASK: {id: 22, label: 'Midas Touch Task', injectable: true},
                 SOLON_TASK: {id: 23, label: 'Solon Task', injectable: true},
                 EVER_GREEN_TASK: { id: 24, label: 'Ever Green Task', injectable: false }

               },
               GymeTaskType: {
                 UNKNOWN: {id: 0, label: 'unknown', deprecated: true},
                 INITIALIZE: {id: 1, label: 'initialize', deprecated: true},
                 SYNCHRONIZE: {id: 2, label: 'synchronize'},
                 PUBLICIZE: {id: 3, label: 'publicize'},
                 FETCH_NEW_ACCOUNTS: {id: 4, label: 'fetch new accounts'},
                 REAPPROVE_KEYWORDS: {id: 5, label: 'reapprove keywords', deprecated: true},
                 REAPPROVE_ADCOPIES: {id: 6, label: 'reapprove adcopies', deprecated: true},
                 PUBLICIZE_CRITICAL: {id: 7, label: 'publicize critical'},
                 POIROT: {id: 8, label: 'poirot'},
                 REAPPROVE: {id: 9, label: 'reapprove'},
                 MIGRATE: {id: 10, label: 'migrate'},
                 WASABI: {id: 11, label: 'wasabi'},
               },
               GymeOperand: {
                 MERCHANT: {id: 1, injectable: true},
                 LOCATION: {id: 2, injectable: true},
                 CATEGORY: {id: 3, injectable: true},
                 LOCALE: {id: 4, injectable: true},
                 CATEGORY_KEYPHRASE: {id: 5, injectable: true},
                 CATEGORY_ADCOPY: {id: 6, injectable: true},
                 LOCALE_GEO_MODIFIER: {id: 7, injectable: true},
                 LOCALE_GEO_TARGET: {id: 8, injectable: true},
                 LOCALE_GEO_CODE: {id: 9, injectable: true},
                 BUDGET: {id: 10, injectable: true},
                 ELIXIR: {id: 11},
                 LOCATION_SITE_LINKS: {id: 12, injectable: true},
                 LOCATION_GEO_MODIFIER: {id: 13},
                 LOCATION_GEO_TARGET: {id: 14},
                 LOCATION_POINT_RADIUS: {id: 15},
                 LOCATION_AD_SCHEDULE: {id: 16}
               },
               GymeOperator: {
                 ADD: {id: 1},
                 REMOVE: {id: 2},
                 UPDATE: {id: 3}
               },
               GymeOperationPriority: {
                 HIGH: {id: 1},
                 MEDIUM: {id: 2},
                 LOW: {id: 3}
               },
               FeedType: {
                 UNKNOWN: {id: 0, label: 'unknown'},
                 MERCHANT: {id: 1, label: 'merchant'},
                 ASH: {id: 2, label: 'ash'},
                 SEARCH_ENGINE: {id: 3, label: 'search engine'},
                 AXE_HOURLY: {id: 4, label: 'axe hourly'},
                 AXE_DAILY: {id: 5, label: 'axe daily'},
                 CATEGORY: {id: 6, label: 'category'},
                 LOCALE: {id: 7, label: 'locale'},
                 AXE_CATEGORY: {id: 8, label: 'axe category'},
                 PERFORMANCE: {id: 9, label: 'performance'},
                 AXE_LOCALE: {id: 10, label: 'axe locale'},
                 GYM_IMP: {id: 11, label: 'gym imp'},
                 CATEGORY_REPORT: {id: 12, label: 'category report'},
                 GEO_CODE: {id: 13, label: 'geo code feed'},
                 MERCHANT_REPORT: {id: 14, label: 'merchant report'},
                 BUDGET_INITIALIZATION: {id: 15, label: 'budget initialization'},
                 AXE_ID: {id: 16, label: 'axe id'},
                 GOOGLE_IMPRESSION: {id: 17, label: 'google impression'},
                 GOOGLE_IMPRESSION_FETCHER: {id: 18, label: 'google impression fetcher'},
                 MIGRATE_EXTERNAL_IDS: {id: 19, label: 'migrate external ids'},
                 CALL_TRACKING_REPORT: {id: 20, label: 'call tracking report'},
                 CALL_TRACKING_REPORT_FETCHER: {id: 21, label: 'call tracking report fetcher'},
                 GYME_RECONCILIATION: {id: 22, label: 'gyme reconciliation'},
                 GYME_RECONCILIATION_FETCHER: {id: 23, label: 'gyme reconciliation fetcher'},
                 TRU_MEASURE_REPORT: {id: 24, label: 'tru measure report'},
                 MONTHLY_BILLING_REPORT: {id: 25, label: 'monthly billing report'},
                 MSN_IMPRESSION: {id: 26, label: 'msn impression'},
                 MSN_IMPRESSION_FETCHER: {id: 27, label: 'msn impression fetcher'},
                 LEAD: {id: 28, label: 'lead feed'},
                 FACEBOOK_IMPRESSION: {id: 29, label: 'facebook impression'},
                 GYME_RERECONCILIATION: {id: 30, label: 'gyme re-reconciliation'},
                 GYME_RERECONCILIATION_FETCHER: {id: 31, label: 'gyme re-reconciliation fetcher'},
                 ALCHEMY_RECONCILIATION: {id: 32, label: 'alchemy reconciliation'},
                 ALCHEMY_RECONCILIATION_FETCHER: {id: 33, label: 'alchemy reconciliation fetcher'},
                 ALCHEMY_RE_RECONCILIATION: {id: 34, label: 'alchemy re-reconciliation'},
                 ALCHEMY_RE_RECONCILIATION_FETCHER: {id: 35, label: 'alchemy re-reconciliation fetcher'},
                 TELMETRICS_CALL_TRACKING_REPORT: {id: 36, label: 'telmetrics call tracking report'},
                 TELMETRICS_CALL_TRACKING_REPORT_FETCHER: {id: 37, label: 'telmetrics call tracking report fetcher'},
                 TELMETRICS_CALL_TRACKING_DAILY_REPORT: {id: 38, label: 'telmetrics call daily tracking report'},
                 TELMETRICS_CALL_TRACKING_DAILY_REPORT_FETCHER: {id: 39, label: 'telmetrics call tracking daily report fetcher'},
                 YAHOO_IMPRESSION: {id: 40, label: 'yahoo impression'},
                 YAHOO_IMPRESSION_FETCHER: {id: 41, label: 'yahoo impression fetcher'},
                 MOBILE_BID: {id: 42, label: 'mobile bid'},
                 AD_IMPRESSION: {id: 43, label: 'ad impression'},
                 AD_IMPRESSION_FETCHER: {id: 44, label: 'ad impression fetcher'},
                 IMPRESSION_SHARE: {id: 45, label: 'impression share'},
                 IMPRESSION_SHARE_FETCHER: {id: 46, label: 'impression share fetcher'},
                 CXENSE_IMPRESSION: {id: 47, label: 'cxense impression'},
                 CXENSE_IMPRESSION_FETCHER: {id: 48, label: 'cxense impression fetcher'},
                 GOOGLE_ANALYTICS: {id: 49, label: 'google analytics'},
                 ZENO_ANALYSIS_BID: {id: 50, label: 'zeno analysis bid'},

                 TRUVO_KEYPHRASE_REPORT: {id: 1000, label: 'truvo keyphrase report'},
                 TRUVO_CATEGORY_REPORT: {id: 1001, label: 'truvo category report'},
                 TRUVO_CAMPAIGN_REPORT: {id: 1002, label: 'truvo campaign report'},
                 TRUVO_NEW_MEDIA_PERFORMANCE: {id: 1003, label: 'truvo new media performance'},
                 EDSA_MONTHLY_CORPORATE_REPORT: {id: 1004, label: 'edsa monthly corporate report'},
                 EDSA_FI_MERCHANT_PERFORMANCE: {id: 1005, label: 'edsafi merchant performance'},
                 SENSIS_PERFORMANCE_REPORT: {id: 1006, label: 'sensis merchant performance'},
                 CITYGATE_MERCHANT_PERFORMANCE: {id: 1007, label: 'citygate 360 media performance report'},
                 ENIRO_TAXONOMY_CATEGORY_REPORT: {id: 1008, label: 'eniro taxonomy category report'},
                 ENIRO_PERFORMANCE_REPORT: {id: 1009, label: 'eniro performance report'},
                 MMEDIENII_PERFORMANCE_REPORT: {id: 1010, label: 'mmedienII performance report'}

               },
               BulkChangeOperator: {
                 BULK_CHANGE_FOR_USER_PAUSE_LOCATIONS: {id: 0, label: 'USER PAUSE LOCATIONS', method: 'bulkChangeForUserPauseLocations'},
                 BULK_CHANGE_FOR_USER_PAUSE_MERCHANTS: {id: 1, label: 'USER PAUSE MERCHANTS', method: 'bulkChangeForUserPauseMerchants'},
                 BULK_CHANGE_FOR_USER_RESUME_MERCHANTS: {id: 2, label: 'USER RESUME MERCHANTS', method: 'bulkChangeForUserResumeMerchants'},
                 BULK_CHANGE_FOR_USER_RESUME_LOCATIONS: {id: 3, label: 'USER RESUME LOCATIONS', method: 'bulkChangeForUserResumeLocations'},
                 BULK_CHANGE_FOR_USER_DELETE_MERCHANTS: {id: 4, label: 'USER DELETE MERCHANTS', method: 'bulkChangeForUserDeleteMerchants'},
                 BULK_CHANGE_FOR_USER_UNDELETE_MERCHANTS: {id: 5, label: 'USER UNDELETE MERCHANTS', method: 'bulkChangeForUserUnDeleteMerchants'}
               },
               ImportFeedStatKey: {
                 MERCHANT_CREATE: {id: 1, label: 'merchant create'},
                 MERCHANT_DELETE_ACTIVE: {id: 2, label: 'merchant delete active'},
                 MERCHANT_DELETE_INACTIVE: {id: 3, label: 'merchant delete inactive'},
                 MERCHANT_CHANGE_NAME: {id: 4, label: 'merchant change name'},
                 MERCHANT_DUPLICATE_ID: {id: 5, label: 'merchant duplicate id'},
                 MERCHANT_BAD_BUDGET_SPECIFICATION: {id: 6, label: 'merchant bad budget specification'},
                 MERCHANT_FAILED_TO_IMPORT: {id: 7, label: 'merchant failed import process'},
                 MERCHANT_UNDELETE: {id: 8, label: 'merchant undeleted'},
                 MERCHANT_BAD_BUDGET_MODIFICATION: {id: 9, label: 'merchant bad budget modification'},
                 MERCHANT_CHANGE_CONTACT_EMAIL: {id: 10, label: 'merchant change contact email'},
                 MERCHANT_CHANGE_CONTACT_FIRST_NAME: {id: 11, label: 'merchant change contact first name'},
                 MERCHANT_CHANGE_CONTACT_LAST_NAME: {id: 12, label: 'merchant change contact last name'},
                 LOCATION_CREATE: {id: 101, label: 'location create'},
                 LOCATION_DELETE_ACTIVE: {id: 102, label: 'location delete active'},
                 LOCATION_DELETE_INACTIVE: {id: 103, label: 'location delete inactive'},
                 LOCATION_CHANGE_NAME: {id: 104, label: 'location change name'},
                 LOCATION_CHANGE_DESTINATION_URL: {id: 105, label: 'location change destination url'},
                 LOCATION_CHANGE_DISPLAY_URL: {id: 106, label: 'location change display url'},
                 LOCATION_DUPLICATE_ID: {id: 107, label: 'location duplicate id'},
                 LOCATION_BAD_DESTINATION_URL: {id: 108, label: 'location bad destination url'},
                 LOCATION_BAD_DISPLAY_URL: {id: 109, label: 'location bad display url'},
                 LOCATION_BAD_LANGUAGE: {id: 110, label: 'location bad language'},
                 LOCATION_INCOMPATIBLE_URLS: {id: 111, label: 'location incompatible urls'},
                 LOCATION_CATEGORY_REFERENCE_NAME_MISMATCH: {id: 112, label: 'location category reference name mismatch'},
                 LOCATION_LOCALE_REFERENCE_NAME_MISMATCH: {id: 113, label: 'location locale reference name mismatch'},
                 LOCATION_BAD_BUDGET_SPECIFICATION: {id: 114, label: 'merchant bad budget specification'},
                 LOCATION_UNRECOGNIZED_CATEGORY_ID: {id: 115, label: 'location unrecognized category id'},
                 LOCATION_DUPLICATE_CATEGORY_ID: {id: 116, label: 'location duplicate category id'},
                 LOCATION_UNDELETE: {id: 117, label: 'location undeleted'},
                 LOCATION_CATEGORY_REFERENCE_ADD: {id: 118, label: 'location category reference add'},
                 LOCATION_CATEGORY_REFERENCE_DELETE: {id: 119, label: 'location category reference delete'},
                 LOCATION_LOCALE_REFERENCE_ADD: {id: 120, label: 'location locale reference add'},
                 LOCATION_LOCALE_REFERENCE_DELETE: {id: 121, label: 'location locale reference delete'},
                 LOCATION_REFERENCE_DELETED_CATEGORY: {id: 122, label: 'location reference deleted category'},
                 LOCATION_UNKNOWN_POSTAL_CODE: {id: 123, label: 'location unknown postal code'},
                 LOCATION_NO_LOCALES_FOR_POSTAL_CODES: {id: 124, label: 'location no locales for postal codes'},
                 LOCATION_LOCALES_INSUFFICIENT_POPULATION: {id: 125, label: 'location locales insufficient population'},
                 LOCATION_UNRECOGNIZED_LOCALE_ID: {id: 126, label: 'location unrecognized locale id'},
                 LOCATION_POINT_RADIUS_ADD: {id: 127, label: 'location point radius add'},
                 LOCATION_POINT_RADIUS_DELETE: {id: 128, label: 'location point radius delete'},
                 LOCATION_GEO_TARGET_ADD: {id: 129, label: 'location geographic target add'},
                 LOCATION_GEO_TARGET_DELETE: {id: 130, label: 'location geographic target delete'},
                 LOCATION_GEO_MODIFIER_ADD: {id: 131, label: 'location geomodifier add'},
                 LOCATION_GEO_MODIFIER_DELETE: {id: 132, label: 'location geomodifier delete'},
                 BUDGET_CREATE: {id: 200, label: 'budget create'},
                 BUDGET_SYSTEM_DELETE: {id: 201, label: 'budget system delete'},
                 BUDGET_CHANGE_TARGET: {id: 202, label: 'budget change target'},
                 BUDGET_CHANGE_TARGET_TYPE: {id: 203, label: 'budget change target type'},
                 BUDGET_CHANGE_BEGIN_DATE: {id: 204, label: 'budget change begin date'},
                 BUDGET_CHANGE_END_DATE: {id: 205, label: 'budget change end date'},
                 BUDGET_CHANGE_INITIAL_CLICKS: {id: 206, label: 'budget change initial clicks'},
                 BUDGET_LONG_TIME_INTERVAL: {id: 207, label: 'budget long time interval'},
                 BUDGET_LOST_ORGANIC_CLICKS: {id: 208, label: 'budget lost organic clicks'},
                 BUDGET_SYSTEM_UNDELETED: {id: 209, label: 'budget system undelete'},
                 BUDGET_ATTEMPT_MODIFY_PAST: {id: 210, label: 'budget attempt modify past'},
                 BUDGET_DELETE_FUTURE: {id: 211, label: 'budget delete future'},
                 BUDGET_ADD_FUTURE: {id: 212, label: 'budget add future'},
                 BUDGET_SYSTEM_CHANGE_CONTRACTED_BEGIN_DATE: {id: 213, label: 'budget system change contracted begin date'},
                 BUDGET_SYSTEM_CHANGE_CONTRACTED_END_DATE: {id: 214, label: 'budget system change contracted end date'},
                 BUDGET_DELETION_FAILURE: {id: 215, label: 'budget deletion failure'},
                 CATEGORY_CREATE: {id: 301, label: 'category create'},
                 CATEGORY_CREATE_KEYWORD: {id: 302, label: 'category create keyword'},
                 CATEGORY_CREATE_ADCOPY: {id: 303, label: 'category create adcopy'},
                 CATEGORY_DELETE: {id: 304, label: 'category delete'},
                 CATEGORY_DELETE_KEYWORD: {id: 305, label: 'category delete keyword'},
                 CATEGORY_DELETE_ADCOPY: {id: 306, label: 'category delete adcopy'},
                 CATEGORY_CHANGE_NAME: {id: 307, label: 'category change name'},
                 CATEGORY_DUPLICATE_ID: {id: 308, label: 'category duplicate id'},
                 CATEGORY_DUPLICATE_KEYPHRASE: {id: 309, label: 'category duplicate keyphrase'},
                 CATEGORY_DUPLICATE_KEYPHRASE_DIFFERENT_ENGINES: {id: 310, label: 'category duplicate keyphrase different engines'},
                 CATEGORY_EXCESSIVE_KEYPHRASES: {id: 311, label: 'category excessive keyphrases'},
                 CATEGORY_NO_ADCOPY: {id: 312, label: 'category no adcopy'},
                 CATEGORY_NO_KEYPHRASE: {id: 313, label: 'category no keyphrase'},
                 CATEGORY_NO_ADCOPY_SOME_ENGINES: {id: 314, label: 'category no adcopy some engines'},
                 CATEGORY_NO_KEYPHRASE_SOME_ENGINES: {id: 315, label: 'category no keyphrase some engines'},
                 CATEGORY_ADCOPY_PROBLEM: {id: 316, label: 'category adcopy problem'},
                 CATEGORY_KEYPHRASE_PROBLEM: {id: 317, label: 'category keyphrase problem'},
                 CATEGORY_CHANGE_CPC_CAP: {id: 318, label: 'category change cpc cap'},
                 CATEGORY_UNDELETE: {id: 319, label: 'category undelete'},
                 CATEGORY_ADCOPY_CHANGE_SUPPRESS_DKI: {id: 320, label: 'category adcopy change suppress dki'},
                 CATEGORY_ADCOPY_CHANGE_MOBILE_ONLY_AD: {id: 321, label: 'category adcopy change mobile only ad'},
                 LOCALE_CREATE: {id: 401, label: 'locale create'},
                 LOCALE_CREATE_KEYWORD: {id: 402, label: 'locale create keyword'},
                 LOCALE_CREATE_IP_TARGET: {id: 403, label: 'locale create ip target'},
                 LOCALE_DELETE: {id: 404, label: 'locale delete'},
                 LOCALE_DELETE_KEYWORD: {id: 405, label: 'locale delete keyword'},
                 LOCALE_DELETE_IP_TARGET: {id: 406, label: 'locale delete ip target'},
                 LOCALE_CHANGE_NAME: {id: 407, label: 'locale change name'},
                 LOCALE_DUPLICATE_ID: {id: 408, label: 'locale duplicate id'},
                 LOCALE_UNDELETE: {id: 409, label: 'locale undelete'},
                 USER_PROFILE_CREATE: {id: 501, label: 'user profile create'},
               },
               PoirotStatsKeyEnum: {
                 CAMPAIGN_MALFORMED: {id: 0, label: 'campaign malformed' },
                 CAMPAIGN_MISSING: {id: 1, label: 'campaign missing' },
                 CAMPAIGN_UNRECOGNIZED: {id: 2, label: 'campaign unrecognized' },
                 ADGROUP_MALFORMED: {id: 3, label: 'adgroup malformed' },
                 ADGROUP_MISSING: {id: 4, label: 'adgroup missing' },
                 ADGROUP_UNRECOGNIZED: {id: 5, label: 'adgroup unrecognized' },
                 ADCOPY_DISAPPROVED: {id: 6, label: 'adcopy disapproved' },
                 ADCOPY_MALFORMED: {id: 7, label: 'adcopy malformed' },
                 ADCOPY_MISSING: {id: 8, label: 'adcopy missing' },
                 ADCOPY_UNRECOGNIZED: {id: 9, label: 'adcopy unrecognized' },
                 KEYWORD_DISAPPROVED: {id: 10, label: 'keyword disapproved' },
                 KEYWORD_MALFORMED: {id: 11, label: 'keyword malformed' },
                 KEYWORD_MISSING: {id: 12, label: 'keyword missing' },
                 KEYWORD_UNRECOGNIZED: {id: 13, label: 'keyword uncrecognized' },
                 AD_EXTENSION_MISSING: {id: 14, label: 'ad extension missing' },
                 AD_EXTENSION_UNRECOGNIZED: {id: 15, label: 'ad extension unrecognized' },
                 TARGET_MALFORMED: {id: 16, label: 'target malformed' },
                 ACCOUNT_MALFORMED: {id: 17, label: 'account malformed' },
                 KEYWORD_DELETED: {id: 18, label: 'keyword deleted' },
                 AD_EXTENSION_MALFORMED: {id: 19, label: 'ad extension malformed' },
                 AD_EXTENSION_DISAPPROVED: {id: 20, label: 'ad extension disapproved' },
                 PLACEMENT_MALFORMED: {id: 21, label: 'placement malformed' },
                 PLACEMENT_MISSING: {id: 22, label: 'placement missing' },
                 PLACEMENT_UNRECOGNIZED: {id: 23, label: 'ad extension disapproved' },
               },
               Capability: {
                 SUPER_USER: { id: 1, label: 'Super User' },
                 OPERATOR: { id: 2, label: 'Operator' },
                 VIEW_OPERATOR: { id: 3, label: 'Operator View Only' },
                 CLIENT_SERVICES_UPLOADER: { id: 4, label: 'Client Services Uploader' },
                 BULK_LOADER: { id: 5, label: 'Bulk Loader' },
                 EMERGENCY_PAUSE: { id: 6, label: 'Emergency Pause' },
                 EMERGENCY_RESUME: { id: 7, label: 'Emergency Resume' },

                 VIEW_ADMIN: { id: 10, label: 'View Admin' },
                 EDIT_ADMIN: { id: 11, label: 'Edit Admin' },
                 VIEW_MERCHANT: { id: 20, label: 'View Merchant' },
                 EDIT_MERCHANT: { id: 21, label: 'Edit Merchant' },
                 EDIT_MERCHANT_PROVISION_REVERSE_PROXY: { id: 22, label: 'Provision Merchant Reverse Proxy' },  // not used anymore
                 VIEW_MERCHANT_PERFORMANCE: { id: 23, label: 'View Campaign Performance' },
                 VIEW_PROVISIONING: { id: 24, label: 'View Provisioning' },
                 VIEW_CATEGORY: { id: 30, label: 'View Category' },
                 EDIT_CATEGORY: { id: 31, label: 'Edit Category' },
                 VIEW_LOCALE: { id: 40, label: 'View Locale' },
                 EDIT_LOCALE: { id: 41, label: 'Edit Locale' },
                 VIEW_MANAGEMENT_HIERARCHY: { id: 51, label: 'View Management Hierarchy' },
                 EDIT_MANAGEMENT_HIERARCHY: { id: 52, label: 'Edit Management Hierarchy' },
                 VIEW_ALL_CLIENT_DATA: { id: 53, label: 'View All Client Data' }, // ignore management hierarchy
                 VIEW_DISAPPROVAL: { id: 54, label: 'View Disapproval' },
                 EDIT_DISAPPROVAL: { id: 55, label: 'Edit Disapproval' },
                 VIEW_DIAGNOSTICS: { id: 56, label: 'View Diagnostics' },
                 EDIT_BID_FACTORS: { id: 57, label: 'Edit Bid Factors' },

                 VIEW_TRANSLATION: { id: 60, label: 'View Translation' },
                 EDIT_TRANSLATION: { id: 61, label: 'Edit Translation' },
                 CREATE_TRANSLATION_KEY: { id: 62, label: 'Create Translation' },

                 VIEW_REPORT_DASHBOARD: { id: 99, label: 'View Report Dashboard' },
                 VIEW_REPORT_MERCHANT: { id: 100, label: 'View Report Merchant' },
                 VIEW_REPORT_MERCHANTS: { id: 101, label: 'View Report Merchants' },
                 VIEW_REPORT_CATEGORIES: { id: 102, label: 'View Report Categories' },
                 VIEW_REPORT_LOCALES: { id: 103, label: 'View Report Locales' },
                 VIEW_REPORT_CATLOCALES: { id: 104, label: 'View Report CatLocales' },
                 VIEW_REPORT_ADHOC: { id: 105, label: 'View Report Adhoc' },
                 VIEW_REPORT_VISUAL_MAP: { id: 106, label: 'View Report Visual Map' },
                 VIEW_REPORT_VISUAL_MOTION: { id: 107, label: 'View Report Visual Motion' },
                 VIEW_REPORT_BUDGET_STATUS: { id: 108, label: 'View Report Budget Status' },
                 VIEW_REPORT_CUSTOM: { id: 109, label: 'View Report Custom' },
                 VIEW_REPORT_CATEGORY_DEFICIT: { id: 110, label: 'View Report Category Deficit' },
                 VIEW_REPORT_DASHBOARD_PACING: { id: 111, label: 'View Report Dashboard Pacing' },

                 ESTIMATOR: { id: 200, label: 'Create Estimates' },

                 NO_SAFE_HARBOR_DATA: { id: 300, label: 'No Safe Harbor Data' },

                 TAXONOMY_VIEW: { id: 400, label: 'View Taxonomy' },
                 TAXONOMY_CREATE_TASK: { id: 401, label: 'Create Taxonomy Task' },
                 TAXONOMY_EDIT_CATEGORY: { id: 410, label: 'Edit Taxonomy Category' },
                 TAXONOMY_PUBLISH: { id: 420, label: 'Taxonomy Publish' },

                 ADMIN_REVERSE_PROXY: { id: 500, label: 'Admin Reverse Proxy' },

                 SHOW_GOOGLE_TESTING_FEATURES: { id: 1000, label: 'DO NOT USE -- Show Google Testing Features' },
                 EXPERIMENTAL_FEATURES: { id: 1001, label: 'Experimental Features' },
                 DEMO_USER: { id: 1002, label: 'Demo User' },
                 REQUEST_SYSTEM_RESTART_DELAY: { id: 1003, label: 'Request System Restart Delay' }
               },
               TruStatusStatKey: {
                 ACTIVE: { id: 0, label: 'active' },
                 PENDINGREVIEW: { id: 1, label: 'pending review' },
                 EXPIRED: { id: 2, label: 'expired' },
                 CANCELLED: { id: 3, label: 'cancelled' },
                 REJECTED: { id: 4, label: 'rejected' }
               },
               BondingStateKey: {
                 UNKNOWN: {id: 0, label: 'Unknown'},
                 PENDING_INVITATION: {id: 1, label: 'Pending Invitation'},
                 AWAITING_INVITATION_RESPONSE: {id: 2, label: 'Awaiting Invitation Response'},

                 READY_FOR_DRY_RUN: {id: 10, label: 'Ready for Dry Run'},
                 PENDING_DRY_RUN: {id: 11, label: 'Pending Dry Run'},
                 DRY_RUN_FAILED: {id: 12, label: 'Dry Run Failed'},
                 DRY_RUN_PASSED: {id:13, label: 'Dry Run Passed'},

                 READY_FOR_BONDING: {id: 20, label: 'Ready for Bonding'},
                 PENDING_BONDING: {id: 21, label: 'Pending Bonding'},
                 BONDING_FAILED: {id: 22, label: 'Bonding Failed'},

                 BONDED: {id: 30, label: 'Bonded'},

                 RELEASED: {id: 40, label: 'Released'},

                 TERMINATED: {id: 50, label: 'Terminated'}
               },
               BidderAction: {
                 UNKNOWN: {id:0, label:'unknown'},
                 STOP: {id:1, label:'stop'},
                 PAUSE: {id:2, label:'pause'},
                 PAUSE_INCREASE_BID: {id:3, label:'pause_increase_bid'},
                 PAUSE_DECREASE_BID: {id:4, label:'pause_decrease_bid'},
                 RESUME: {id:5, label:'resume'},
                 RESUME_INCREASE_BID: {id:6, label:'resume_increase_bid'},
                 RESUME_DECREASE_BID: {id:7, label:'resume_decrease_bid'},
                 RESUME_FOR_CATCH_UP: {id:8, label:'resume_for_catch_up'},
                 CONTINUE: {id:9, label:'continue'},
                 CONTINUE_INCREASE_BID: {id:10, label:'continue_increase_bid'},
                 CONTINUE_DECREASE_BID: {id:11, label:'continue_decrease_bid'},
                 PSEUDO_PAUSE_DECREASE_BID: {id:12, label:'pseudo_pause_decrease_bid'},
                 RESUME_PSEUDO_PAUSE: {id:13, label:'resume_pseudo_pause'}},
               AnalysisOrderEnum: {
                 ADVERTISER_DATA: {id: 0, label: 'Campaign\'s data' },
                 TAXONOMY_CRAWL0: {id: 1, label: 'Taxonomy data, no crawl' },
                 TAXONOMY_CRAWL1: {id: 2, label: 'Taxonomy data, crawl up 1 level' },
                 TAXONOMY_CRAWL2: {id: 3, label: 'Taxonomy data, crawl up 2 levels' },
                 TAXONOMY_CRAWL3: {id: 4, label: 'Taxonomy data, crawl up 3 levels' },
                 TAXONOMY_CRAWL4: {id: 5, label: 'Taxonomy data, crawl up 4 levels' },
                 TAXONOMY_OVERALL: {id: 6, label: 'Overall taxonomy averages' },
                 WORLD_LEVEL: {id: 7, label: 'World level' }
               },
               ZenoReasonEnum: {
                 DESIRED_FACTOR_EXCEEDS_LIMITS: {id: 1, label: 'Desired factor exceeds limits' },
                 BALANCE_CLOSE_TO_TARGET: {id: 2, label: 'Balance is close to budget target' },
                 BALANCE_NEARLY_CLOSE_TO_TARGET: {id: 3, label: 'Balance is getting close to budget target' },
                 BALANCE_FAR_FROM_TARGET: {id: 4, label: 'Balance is far from budget target' },
                 INSUFFICIENT_RECENT_DATA: {id: 5, label: 'Insufficient recent data'}
               },
               TaxonomyTaskType: {
                 ON_DEMAND: { id: 1, label: 'On Demand Request' },
                 REBUILD: { id: 2, label: 'Rebuild / Rework Request' }
               },
               TaxonomySubtaskType: {
                 CREATE: { id: 1, label: 'Create' },
                 EDIT: { id: 2, label: 'Edit' },
                 DELETE: { id: 3, label: 'Delete' },
                 UNDELETE: { id: 4, label: 'Undelete' }
               },
               TaxonomySubtaskState: {
                 OPEN: { id: 1, label: 'Open'},
                 CANCELED: { id: 2, label: 'Canceled' },
                 PUBLISHED: { id: 3, label: 'Published' }
               },
               FieldType: {
                 BOOLEAN: { id: 1 },
                 INTEGER: { id: 2 },
                 FLOAT: { id: 3 },
                 STRING: { id: 4 },
                 DATE: { id: 5 },
                 IMAGE: { id: 6 },
                 FILE: { id: 7 },
                 SELECT: { id: 8 },
                 MEDIA: { id: 9 }
               },
               TestResult: {
                 PASSED: { id: 0 },
                 FAILED: { id: 1}
               },
               SitelinkEditorEnum : { ADD: { id: 0},
                                      EDIT_ONE: { id: 1},
                                      EDIT_MULTIPLE: { id: 2}},
               CalloutEditorEnum : { ADD: { id: 0},
                                     EDIT_ONE: { id: 1},
                                     EDIT_MULTIPLE: { id: 2}},
               SpendManagementFeeTypeEnum: {
                 FIXED: { id: 0, label: 'Fixed' },
                 TIERS: { id: 1, label: 'TIER' }
               }
             };
    }

    return RipEnum;

  })({ }));
